import {
  ApiTeamPageInfo,
  TeamPageInfo,
  apiTeamPageInfoToTeamPageInfo
} from "../../apiResponse/team-page-info";

export interface ApiOrganizationCustomization {
  AccountId: string;
  Created: string;
  Modified: string;
  OrganizationAvatar: string;
  OrganizationAvatarUrl: string;
  OrganizationCustomizationId: string;
  OrganizationId: string;
  OrganizationInfo: { TeamPageInfo?: ApiTeamPageInfo };
}

export interface OrganizationCustomization {
  accountId: string;
  created: string;
  modified: string;
  organizationAvatar: string;
  organizationAvatarUrl: string;
  organizationCustomizationId: string;
  organizationId: string;
  organizationInfo: { teamPageInfo: TeamPageInfo };
}

export function apiOrganizationCustomizationToOrganizationCustomization(
  apiOrganizationCustomization: ApiOrganizationCustomization
): OrganizationCustomization {
  return {
    accountId: apiOrganizationCustomization.AccountId,
    created: apiOrganizationCustomization.Created,
    modified: apiOrganizationCustomization.Modified,
    organizationAvatar: apiOrganizationCustomization.OrganizationAvatar,
    organizationAvatarUrl: apiOrganizationCustomization.OrganizationAvatarUrl,
    organizationCustomizationId: apiOrganizationCustomization.OrganizationCustomizationId,
    organizationId: apiOrganizationCustomization.OrganizationId,
    organizationInfo: {
      teamPageInfo: apiTeamPageInfoToTeamPageInfo(
        apiOrganizationCustomization.OrganizationInfo.TeamPageInfo
      )
    }
  };
}
